import { Link } from '@ipfabric/ui-components/Link/Link';
import {
  type TableColumnFormatInterface,
  getValueFromKeyOfType,
} from '@ipfabric/utils';
import type { RenderedTableCell } from 'components/Table/cells/RenderedTableCell';
import type { RenderCellContentArguments } from '../model/TableCellContentRenderFunction';

export const renderInterfaceCell = <TRow,>(
  format: TableColumnFormatInterface<TRow>,
  { row, context, index, severity }: RenderCellContentArguments<TRow>,
): RenderedTableCell => {
  const intName = getValueFromKeyOfType(row, format.field);
  const sn = getValueFromKeyOfType(row, format.snField);

  const content =
    !intName ||
    !sn ||
    sn === 'unknown' ||
    !context.onShowDetailClick ||
    context.disableLinks ||
    context.detailView ? (
      intName
    ) : (
      <Link
        renderAs='button'
        accent={severity === null ? 'positive' : 'contrast'}
        onClick={() => {
          context.onShowDetailClick?.(index, format.field as string);
        }}
      >
        {intName}
      </Link>
    );

  return {
    content,
  };
};
